const wrapper = "_35sw1v5pyta";

export { wrapper };
import "./molecule.content.style.linaria.module.css";
//# sourceMappingURL=molecule.content.style.js.map
